module.exports = __webpack_public_path__ + "img/dotTrace_icon.231f8913.png";